export default {
   name: 'Welcome',
   created() {
      this.$store.dispatch('title','Inicio')
   },
   data() {
      return {}
   }
}
